/***
 * 测试
 * */
// export default {
//   // 获取当前时间
//   getNowTime () {
//     console.log(new Date())
//   },
//   // 打印一段字符串
//   showMessage (msg) {
//     console.log(msg)
//   }
// }

function getNowTime () {
  console.log(new Date())
}

function showMessage (msg) {
  console.log(msg)
}

export {
  getNowTime,
  showMessage
}
